"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _material = require("@ori-ui/mui-bundle/material");
var _jsxRuntime = require("react/jsx-runtime");
var _default = exports.default = (0, _material.createSvgIcon)(/*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
  children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    d: "M12 13.5a.5.5 0 0 1-.5-.5V8a.5.5 0 0 1 1 0v5a.5.5 0 0 1-.5.5m-.5 2a.5.5 0 1 1 1 0 .5.5 0 0 1-1 0"
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    d: "M13.282 4.648a1.5 1.5 0 0 0-2.564 0L3.995 15.721A1.5 1.5 0 0 0 5.277 18h13.446a1.5 1.5 0 0 0 1.282-2.279zm-1.71.52a.5.5 0 0 1 .855 0L19.15 16.24a.5.5 0 0 1-.427.76H5.277a.5.5 0 0 1-.428-.76z"
  })]
}), 'Warning');
